class BESSAppItemQuestionAnswerDependencyEvent extends BESSAppDependencyEvent {
    static name = "BESSAppItemQuestionAnswerDependencyEvent";

    static eventFor(item, questionIdentifier) {
        return BESSAppItemQuestionAnswerDependencyEvent.name + "_" + item.getEventIdentifier() + "_" + questionIdentifier;
    }

    constructor(item, field, value, changing = false) {
        super(BESSAppItemQuestionAnswerDependencyEvent.eventFor(item, field.getEventIdentifier()), value, changing);
        this.item = item;
        this.field = field;
    }

    getValue() {
        if (this.value == null) return null;
        let val = this.value.value;
        if (val == null) return null;
        if (val.key != null) return val.key;
        return val;
    }
}